import { ChangeDetectionStrategy, Component, Type, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AppFacade } from 'ish-core/facades/app.facade';

@Component({
  selector: 'custom-header-navigation',
  templateUrl: './custom-header-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomHeaderNavigationComponent {
  appFacade = inject(AppFacade);
  lazyComponent$: Observable<Type<unknown>> = this.appFacade.loadLazyComponent('header');
}
